export default {
      id: "Icon--species-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--species",
      toString: function () {
        return this.url;
      }
    }